import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ContactUsComponent } from './contact/contactUs.component';
import { ServicesComponent } from './services/services.component';
import { ProductComponent } from './product/product.component';
import { BeautyProductComponent } from './beauty-product/beautyProduct.component';
import { PsiComponent } from './psi/psi.component';
import { AtlPackage1Component } from './atl-package1/atlPackage1.component';
import { AtlPackage2Component } from './atl-package2/atlPackage2.component';
import { AtlPackage3Component } from './atl-package3/atlPackage3.component';
import { AtlPackage4Component } from './atl-package4/atlPackage4.component';
import {WeightMachineComponent} from './weight-machine/weightMachine.component';
const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'service',
    component: ServicesComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'product',
    component: ProductComponent,
  },
  {
    path: 'tool-kit-beauty-wellness-skill-incubation-centre-rm',
    component: BeautyProductComponent
  },
  {
    path: 'weight-machine',
    component: WeightMachineComponent
  },
  {
    path: 'atl-package1',
    component: AtlPackage1Component
  },
  {
    path: 'atl-package2',
    component: AtlPackage2Component
  },
  {
    path: 'atl-package3',
    component: AtlPackage3Component
  },
  {
    path: 'atl-package4',
    component: AtlPackage4Component
  },
  {
    path: 'tool-kit-retail-skill-l-1-rm',
    component: PsiComponent
  },
  {
    path: 'gallery',
    component: GalleryComponent
  },
  {
    path: 'contactUs',
    component: ContactUsComponent
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
 }



// WEBPACK FOOTER //
// D:/xampp/htdocs/Techbotz-master/src/app/app-routing.module.ts